'use strict';

wbApp.directive('wbErrorAlert',
    function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            scope: { serverError: '=ngModel' },
            replace: true,
            template:
                "<div class='alert alert-danger wb-server-alert' ng-show='serverError'>" +
                    "<strong>{{'TXT_TITLE_FIX_ERRORS' | translate}}</strong>" +
                    "<ul ng-show='!!serverError.data.title' class='list-unstyled'><li>{{serverError.data.title}}</li></ul>" +
                    "<ul ng-if='!!serverError.errors'>" +
                        "<li ng-repeat='error in serverError.errors'>{{error.message}}</li>" +
                    "</ul>" +
                    "<ul ng-if='!!serverError.data && !!serverError.data.validationErrors'>" +
                        "<li ng-repeat='error in serverError.data.validationErrors'>{{error.description}}</li>" +
                    "</ul>" +
                "</div>"
        }
    });